import { usePermissions } from "../../contexts/PermissionContext";

/**
 * Convenience hook for checking a single permission.
 *
 * Reads from supplier's PermissionContext (not @hoteltradergit/user-management)
 * so the global test mock in setupTests.js — which mutates
 * DEFAULT_PERMISSION_CONTEXT — keeps working without each test wrapping with
 * <UserManagementProvider>. The package exports its own equivalent for
 * greenfield consumers.
 *
 * @param {string} permKey - Permission key to check
 * @returns {{ allowed: boolean, loading: boolean }}
 */
export const usePermission = (permKey) => {
  const { hasPermission, loading } = usePermissions();
  return { allowed: !loading && hasPermission(permKey), loading };
};
